import { Resource as a, API as i } from "@coveo/platform-client";
const t = class t extends a {
  /**
   * @param params Either the Slack access token to validate or it's corresponding GUID.
   * @returns The token validation result from Slack.
   */
  validateSlackToken(s) {
    let e = "";
    return Object.keys(s).forEach((l) => e += `${l}=${s[l]}&`), this.api.post(
      `${t.getBaseUrl()}/SLACK/validateToken?${e.slice(0, -1)}`
    );
  }
};
t.getBaseUrl = () => `/rest/organizations/${i.orgPlaceholder}/schema/sources`;
let o = t;
export {
  o as SchemaServiceTemporaryResource
};
//# sourceMappingURL=SchemaServiceTemporaryResource.js.map
